import { render } from "./approval-rules.svg?vue&type=template&id=7468b443"
const script = {}
script.render = render

export default script